import React from 'react';
import SystemUpdateAltIcon from '@material-ui/icons/SystemUpdateAlt';
import { mdiAlertCircleOutline } from '@mdi/js';
import IconSize from '../../../../lib/IconSize';
import { SwitchToContainer, NotificationContainer, NotificationIcon, NotificationButton, Notification } from './lab.styles';
const NOTIFICATION_TEXT = 'Virtual labs are only available through the Adept desktop app.';
export const SwitchToApp = ({ isElectron, appDownloadUrl }) => {
    if (isElectron)
        return null;
    return (React.createElement(SwitchToContainer, null,
        React.createElement(NotificationContainer, null,
            React.createElement(NotificationIcon, { path: mdiAlertCircleOutline, size: IconSize.Medium }),
            React.createElement(Notification, null, NOTIFICATION_TEXT)),
        React.createElement(NotificationButton, { variant: "text", color: "primary", startIcon: React.createElement(SystemUpdateAltIcon, null), href: appDownloadUrl }, "Download")));
};
//# sourceMappingURL=SwitchToApp.js.map